// C:\Users\fsuarez\Documents\BVP-MVP\BVP-repo\BVP-Frontend\src\context\HistoryContext.tsx
import React, { createContext, useContext, useState, useCallback } from 'react';
import HistoryModal from '../pages/GradeReports/ReviewReport/HistoryModal';


const HistoryContext = createContext(undefined);


export const HistoryProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [reportId, setReportId] = useState();

  const openHistory = useCallback((name, id) => {
    setCompanyName(name);
    setReportId(id);
    setIsOpen(true);
  }, []);

  const closeHistory = useCallback(() => {
    setIsOpen(false);
  }, []);

  // Note: The HistoryModal already has its own internal demo data
  // If you need to pass company-specific data, you might need to modify
  // the HistoryModal component to accept props like companyName and reportId
  return (
    <HistoryContext.Provider value={{ openHistory, closeHistory }}>
      {children}
      <HistoryModal
        open={isOpen}
        onClose={closeHistory}
        companyName={companyName}
      />
    </HistoryContext.Provider>
  );
};

// Custom hook to use history context
export const useHistory = () => {
  const context = useContext(HistoryContext);
  if (context === undefined) {
    throw new Error('useHistory must be used within a HistoryProvider');
  }
  return context;
};